import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchRestaurantFooter } from "../../actions/footerActions";

import { useSelector } from "react-redux";

import {
  useParams,
  useNavigate,
} from "react-router-dom";

import "./css/Footer.css";


function Footer() {

  const {
    restaurantId,
    tableId,
  } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const footer = useSelector((state) => state.footer?.data);
  useEffect(() => {
    if (restaurantId) dispatch(fetchRestaurantFooter(restaurantId)).catch(() => {});
  }, [dispatch, restaurantId]);

  const {
    restaurantName,
  } = useSelector(
    (state) => state.menu
  );


  const goCart = () => {

    navigate(
      `/${restaurantId}/table/${tableId}/cart`
    );

  };


  const scrollToSection = (sectionId) => {

    const section =
      document.getElementById(sectionId);

    if (section) {

      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

    }

  };


  return (
    <footer
      className="theme2-footer"
      id="contact"
    >

      <div className="theme2-footer-main">


        {/* RESTAURANT */}

        <div className="theme2-footer-brand">

          <span className="theme2-footer-eyebrow">
            KITCHEN & SOCIAL
          </span>

          <h2>
            {footer?.restaurant_name || restaurantName || "OUR RESTAURANT"}
          </h2>

        </div>


        {/* ADDRESS */}

        <div className="theme2-footer-column">

          <span className="theme2-footer-heading">
            FIND US
          </span>

          <p>
            {footer?.address || ""}
          </p>

        </div>


        {/* CONTACT */}

        <div className="theme2-footer-column">

          <span className="theme2-footer-heading">
            CONTACT
          </span>

          <p>
            {footer?.phone || ""}
            {footer?.phone && footer?.email && <br />}
            {footer?.email || ""}
          </p>

        </div>


        {/* OPENING HOURS */}

        <div className="theme2-footer-column">

          <span className="theme2-footer-heading">
            OPENING HOURS
          </span>

          <p>
            MON — FRI
            <br />
            {footer?.monday_friday_hours || "—"}
            <br />
            SAT
            <br />
            {footer?.saturday_hours || "—"}
            <br />
            SUN
            <br />
            {footer?.sunday_hours || "—"}
          </p>

        </div>

      </div>


      <p className="theme2-footer-disclaimer">
        {footer?.disclaimer || "Food images are for presentation purposes only. Actual items may vary."}
      </p>

      {/* FOOTER NAVIGATION */}

      <div className="theme2-footer-bottom">

        <div className="theme2-footer-links">

          <button
            type="button"
            onClick={() =>
              scrollToSection("menu")
            }
          >
            MENU
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection("about")
            }
          >
            ABOUT
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection("contact")
            }
          >
            CONTACT
          </button>


          <button
            type="button"
            onClick={goCart}
          >
            YOUR ORDER
          </button>

        </div>


        <div className="theme2-footer-copyright">

          © {new Date().getFullYear()}{" "}

          {footer?.restaurant_name || restaurantName || "RESTAURANT"}

        </div>

      </div>

    
      {/* Restaurant social profiles (only show configured HTTPS/HTTP URLs) */}
      {[
        { field: "facebook_url", label: "Facebook", glyph: "f" },
        { field: "instagram_url", label: "Instagram", glyph: "◎" },
        { field: "youtube_url", label: "YouTube", glyph: "▶" },
        { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
      ].some(({ field }) => /^https?:\/\//i.test((footer?.[field] || "").trim())) && (
        <nav aria-label="Restaurant social media" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center", gap: "14px", padding: "14px 18px" }}>
          {[
            { field: "facebook_url", label: "Facebook", glyph: "f" },
            { field: "instagram_url", label: "Instagram", glyph: "◎" },
            { field: "youtube_url", label: "YouTube", glyph: "▶" },
            { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
          ].filter(({ field }) => /^https?:\/\//i.test((footer?.[field] || "").trim())).map(({ field, label, glyph }) => (
            <a key={field} href={footer[field].trim()} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}
               style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: "32px", minHeight: "32px", color: "inherit", textDecoration: "none", fontWeight: 700, fontSize: "20px" }}>
              {glyph}
            </a>
          ))}
        </nav>
      )}
    </footer>
  );
}


export default Footer;